import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  CreatePositionMutation,
  CreatePositionMutationVariables
} from './__generated__/CreatePositionMutation'
import { positionFragment } from '../fragments/PositionFragment'

const mutation: TypedDocumentNode<
  CreatePositionMutation,
  CreatePositionMutationVariables
> = gql`
  ${positionFragment}

  mutation CreatePositionMutation(
    $input: CreatePositionInput!
    $locale: String
  ) {
    createPosition(input: $input) {
      position {
        ...PositionFragment
      }
    }
  }
`

export function createPositionMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      CreatePositionMutation,
      CreatePositionMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
